// Band+ promo screen (display) — temporary stand-in for the upgrade card.
// Passive pulsing art + Watch Demo button. Video treatment ported from
// VipUpgradePromo: centered pop-out card, dark veil, X close, controls,
// try-unmuted-then-muted-fallback with a Tap to Unmute escape hatch.
// Hides the global BottomBar while open (PhotoFrame pattern); red EXIT
// button top-right returns to Home.

import { useEffect, useRef, useState } from "react";



const PULSE_SECONDS = 3;
const DEMO_VIDEO_URL = "https://cdn.mywaitserver.live/beaconpromo720.mp4";

const BCD_STYLE = `
  .bcd-root {
    position: fixed; inset: 0;
    background: #000;
    overflow: hidden;
    pointer-events: none;
  }
  .bcd-img {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover;
    display: block;
  }
  .bcd-pulse {
    opacity: 0;
    animation: bcd-pulse ${PULSE_SECONDS}s ease-in-out infinite;
  }
  @keyframes bcd-pulse {
    0%   { opacity: 0; }
    50%  { opacity: 1; }
    100% { opacity: 0; }
  }
  .bcd-exit-btn {
    position: absolute;
    top: 16px; right: 16px;
    pointer-events: auto;
    background: rgba(220,38,38,0.85);
    color: #fff;
    font-family: 'Lato', sans-serif; font-weight: 700;
    border: 3px solid rgba(255,255,255,0.9);
    border-radius: 14px;
    padding: 8px 22px;
    font-size: 20px;
    cursor: pointer; letter-spacing: 1px; outline: none;
    -webkit-tap-highlight-color: transparent;
  }
  .bcd-demo-btn {
    position: absolute;
    left: 0; right: 0; bottom: 110px;
    margin: 0 auto;
    width: max-content;
    pointer-events: auto;
    background: linear-gradient(90deg, #4e54c8, #8f94fb);
    color: white;
    border: 6px solid #2c0066;
    border-radius: 16px;
    padding: 16px 50px;
    font-family: 'Lato', sans-serif; font-weight: 700; font-size: 30px;
    cursor: pointer; outline: none;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3), 0 0 20px rgba(142, 148, 251, 0.6),
      inset 0 0 10px rgba(255, 255, 255, 0.2);
    animation: bcd-pulseTour 1.2s infinite ease-in-out;
    -webkit-tap-highlight-color: transparent;
  }
  @keyframes bcd-pulseTour {
    0%, 100% {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3), 0 0 20px rgba(142, 148, 251, 0.6),
        inset 0 0 10px rgba(255, 255, 255, 0.2);
    }
    50% {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4), 0 0 28px rgba(142, 148, 251, 0.8),
        inset 0 0 12px rgba(255, 255, 255, 0.3);
    }
  }
  .bcd-video-root {
    position: fixed; inset: 0;
    z-index: 9990;
    pointer-events: auto;
    background: rgba(0, 0, 0, 0.88);
    display: grid; place-items: center;
  }
  .bcd-video-card {
    position: relative;
    z-index: 10000;
    width: min(96vw, 1300px);
    aspect-ratio: 16 / 9;
    max-height: min(88vh, 760px);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0,0,0,.6);
    background: #000;
  }
  .bcd-video {
    width: 100%; height: 100%;
    object-fit: cover;
    object-position: center center;
    display: block;
    background-color: #000;
  }
  .bcd-video-close {
    position: fixed;
    top: 16px; right: 24px;
    z-index: 10001;
    font-size: 56px;
    color: white;
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'Lato', sans-serif;
  }
  .bcd-unmute-btn {
    position: absolute;
    right: 12px; bottom: 12px;
    z-index: 10002;
    padding: 10px 14px;
    border-radius: 8px;
    border: 0;
    background: rgba(0,0,0,.65);
    color: #fff;
    font-family: 'Lato', sans-serif;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
  }
`;

export default function BeaconComingDisplay() {
  
  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [mutedFallback, setMutedFallback] = useState(false);
  const [pendingUnmutedAttempt, setPendingUnmutedAttempt] = useState(false);


  useEffect(() => {
    if (!showVideo || !pendingUnmutedAttempt) return;
    const v = videoRef.current;
    if (!v) return;
    (async () => {
      try {
        v.muted = false;
        v.volume = 0.5;
        await v.play();
        setMutedFallback(false);
        setIsPlaying(true);
      } catch {
        try {
          v.muted = true;
          await v.play();
          setMutedFallback(true);
          setIsPlaying(true);
        } catch {
          setIsPlaying(false);
        }
      } finally {
        setPendingUnmutedAttempt(false);
      }
    })();
  }, [showVideo, pendingUnmutedAttempt]);

  const closeVideo = () => {
    setShowVideo(false);
    setIsPlaying(false);
    setMutedFallback(false);
  };

  return (
    <div className="bcd-root">
      <style>{BCD_STYLE}</style>
      <img className="bcd-img" src="/static/beacon_coming_display.jpg" alt="" />
      <img className="bcd-img bcd-pulse" src="/static/beacon_coming2_display.png" alt="" />

      

      {showVideo && (
        <div className="bcd-video-root">
          <button
            className="bcd-video-close"
            onClick={closeVideo}
            aria-label="Close video"
          >
            ✕
          </button>
          <div className="bcd-video-card">
            <video
              key="beacon-promo-video"
              ref={videoRef}
              className="bcd-video"
              controls
              autoPlay
              playsInline
              preload="auto"
              controlsList="nodownload nofullscreen"
              disablePictureInPicture
              onPlaying={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onEnded={closeVideo}
              onError={() => {
                try {
                  const v = videoRef.current;
                  if (!v) return;
                  v.muted = true;
                  v.load();
                  v.play().catch(() => {});
                  setMutedFallback(true);
                } catch {}
              }}
            >
              <source src={DEMO_VIDEO_URL} type="video/mp4" />
            </video>

            {isPlaying && mutedFallback && (
              <button
                className="bcd-unmute-btn"
                onClick={() => {
                  const v = videoRef.current;
                  if (!v) return;
                  try {
                    v.muted = false;
                    v.volume = 0.5;
                    const p = v.play();
                    if (p && typeof p.then === "function") p.catch(() => {});
                    setMutedFallback(false);
                  } catch {}
                }}
              >
                Tap to Unmute
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
